'use strict';

angular.module('membership')
  .controller('SitesCtrl', [
    '$scope', 'sitesViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.company);
    }
  ]);
